import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';
import { SimulateurComponent } from 'projects/hp-api/src/lib/simulateur/simulateur.component';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-wizard-nav-clone-delete',
  templateUrl: './wizard-nav-clone-delete.component.html',
  styleUrls: ['../../base/wizard/wizard-hp-base-component.scss', './wizard-nav-clone-delete.component.scss'],
  //host: {'class': 'app-wizard-answers-menu'},
  changeDetection: ChangeDetectionStrategy.OnPush,
 
})
export class WizardNavCloneDeleteComponent extends WizardHpBaseComponent implements OnInit {
  @Input() catalog_index;
  constructor(chgDetectorRef: ChangeDetectorRef, mainSimulateur: SimulateurComponent, hpService: HpService, router: Router) {
    super(chgDetectorRef, hpService, router);

  }

  ngOnInit(): void {
    super.ngOnInit();
  }

}
